/* eslint-disable import/no-extraneous-dependencies */
import CustomizationInfoDialog from "src/components/Common/CustomizationInfoDialog";
import { Body, Title } from "sunday-component";
import {
  FacebookMessengerShareButton,
  FacebookShareButton,
  LineShareButton,
} from "react-share";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import { logError } from "src/utils/logger";
import { ShareLinkTextBox } from "../ShareLinkTextBox/ShareLinkTextBox";
import {
  ShareIconContainer,
  ShareLinkTextBoxContainer,
  ShareSectionContainer,
} from "./ShareLinkModal.style";

type ShareLinkModalProps = {
  visible: boolean;
  shareLinkUrl: string;
  onClose: () => void;
  onWriteClipboard: () => void;
};
const ShareLinkModal = ({
  visible,
  shareLinkUrl,
  onClose,
  onWriteClipboard,
}: ShareLinkModalProps) => {
  const { t } = useTranslation("affiliate");
  const userAgent = navigator?.userAgent ?? "";
  const isMobileDevice = /Mobile/i.test(userAgent);

  const handleOnShareMobile = async () => {
    if (navigator?.share) {
      try {
        await navigator.share({
          title: t("report.shareLinkModal.shareTitle"),
          url: shareLinkUrl,
        });
      } catch (error) {
        logError(error);
      }
    }
  };
  return (
    <CustomizationInfoDialog
      isVisible={visible}
      title={t("report.shareLinkModal.title")}
      confirmText={<Title level={7}>{t("report.shareLinkModal.close")}</Title>}
      onConfirm={onClose}
      width={303}
      centered
      body={
        <div style={{ textAlign: "center" }}>
          <Body level={7}>{t("report.shareLinkModal.description")}</Body>
          <ShareLinkTextBoxContainer>
            <ShareLinkTextBox
              shareLinkUrl={shareLinkUrl}
              onWriteClipboard={onWriteClipboard}
            />
          </ShareLinkTextBoxContainer>
          <ShareSectionContainer>
            <ShareIconContainer>
              <FacebookShareButton url={shareLinkUrl}>
                <Image
                  src="/static/pages/affiliatePage/icon-color-facebook_rounded.svg"
                  width={24}
                  height={24}
                  alt="Facebook Messenger Icon"
                />
              </FacebookShareButton>
              <Body level={7}>Facebook</Body>
            </ShareIconContainer>
            <ShareIconContainer>
              {!isMobileDevice && (
                <FacebookMessengerShareButton
                  appId={process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}
                  url={shareLinkUrl}
                >
                  <Image
                    src="/static/pages/affiliatePage/icon-color-messenger_rounded.svg"
                    width={24}
                    height={24}
                    alt="Facebook Messenger Icon"
                  />
                </FacebookMessengerShareButton>
              )}
              {isMobileDevice && (
                <div onClickCapture={handleOnShareMobile}>
                  <Image
                    src="/static/pages/affiliatePage/icon-color-messenger_rounded.svg"
                    width={24}
                    height={24}
                    alt="Facebook Messenger Icon"
                  />
                </div>
              )}
              <Body level={7}>Messenger</Body>
            </ShareIconContainer>
            <ShareIconContainer>
              <LineShareButton url={shareLinkUrl}>
                <Image
                  src="/static/pages/affiliatePage/icon-color-line_rounded.svg"
                  width={24}
                  height={24}
                  alt="Facebook Messenger Icon"
                />
              </LineShareButton>
              <Body level={7}>Line</Body>
            </ShareIconContainer>
          </ShareSectionContainer>
        </div>
      }
    />
  );
};

export default ShareLinkModal;
